"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.u0031 = void 0;
var u0031 = {
  "viewBox": "0 0 2600 2760.837",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1665 2432h-242V1182q0-63 1-130.5t3-129.5l4-127q2-61 3-108-23 25-40.5 42.5T1358 763l-89 79-203 166-132-169 525-409h206v2002z"
    },
    "children": []
  }]
};
exports.u0031 = u0031;